import React, { createContext, useReducer } from 'react';

export const MutationStateContext = createContext('');
export const MutationStateDispatchContext = createContext(() => {});

function reducer(state, action) {
  switch (action.type) {
    case 'LOADING':
      return 'loading';
    case 'FINISHED':
      return 'finished';
    default:
      return '';
  }
}

const MutationStateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, '');

  return (
    <MutationStateDispatchContext.Provider value={dispatch}>
      <MutationStateContext.Provider value={state}>{children}</MutationStateContext.Provider>
    </MutationStateDispatchContext.Provider>
  );
};

export default MutationStateProvider;
